import React from 'react';

const VideoContainer = ({
	question,
	videoUrl,
}) => {
	return (
		<li>
			<div className="poster-view">
				<a href="#">
					<div className="video-img">
						<div dangerouslySetInnerHTML={{ __html: videoUrl }} />
					</div>
					<div className="video-info">
						{question}
					</div>
				</a>
			</div>
		</li>
	);
}
export default VideoContainer;
